import { Box, Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { StandardCost } from 'bom/elements';
import { BomPartHelper } from 'bom/helpers';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Price } from 'core/elements';
import { WarningType } from 'core/enums';
import { getAgGridTableCellData } from 'core/utils';
import { PricingHelper } from 'pricing/helpers';
import { Color } from 'theme/enums';

interface IProps extends ICellRendererParams {
  costDecimals?: number;
}

export const CostCell = ({
  costDecimals = PricingHelper.DEFAULT_COST_DECIMALS,
  ...rest
}: IProps) => {
  const data = getAgGridTableCellData(rest, 'computedCostBase');

  if (!data) {
    return rest?.value;
  }

  const { computedCost, computedPurchaseCost } = data;

  if (!computedPurchaseCost) {
    return <Box sx={{ textAlign: 'right' }}>{DEFAULT_PLACEHOLDER}</Box>;
  }

  const hasWarnings = BomPartHelper.hasExpiredCost(data);

  return (
    <Stack>
      <StandardCost
        cost={computedCost}
        decimals={costDecimals}
        fixedDecimals
        color={hasWarnings ? Color.DANGER : null}
        warningType={WarningType.ERROR}
        label={`${t('labelStandardCost')}:`}
      />

      <Price
        amount={computedPurchaseCost}
        decimals={costDecimals}
        fixedDecimals
        label={`${t('labelCost')}:`}
      />
    </Stack>
  );
};
